import React from 'react';
import { Col, Label } from 'reactstrap';
import { MultiSelect } from '@mantine/core';
import { sanitizeStrArr } from '../utils';

const FiscalizadoresField = ({
	validation,
	fiscalizadorSelectData,
	setCreatedFiscalizadores,
}) => {
	const { values, errors, submitCount, setFieldValue } = validation;

	return (
		<Col lg={12} className='mb-3'>
			<Label className='form-label'>
				Nombre(s) Fiscalizador(es) <span className='text-danger'>*</span>
			</Label>
			<MultiSelect
				data={fiscalizadorSelectData}
				value={sanitizeStrArr(values.fiscalizadores)}
				onChange={value => setFieldValue('fiscalizadores', sanitizeStrArr(value))}
				placeholder='Seleccione o ingrese fiscalizadores'
				searchable
				clearable
				creatable
				getCreateLabel={query => `+ Agregar "${query}"`}
				onCreate={query => {
					const item = { value: query, label: query };
					setCreatedFiscalizadores(prev => [...prev, item]);
					const current = sanitizeStrArr(values.fiscalizadores);
					if (!current.includes(query)) {
						setFieldValue('fiscalizadores', [...current, query]);
					}
					return item;
				}}
				error={submitCount > 0 && errors.fiscalizadores ? errors.fiscalizadores : null}
			/>
		</Col>
	);
};

export default FiscalizadoresField;
